import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard implements CanActivate {
  readonly auth = inject(AuthService);
  readonly router = inject(Router);

  async canActivate(): Promise<boolean> {
    // Wait for auth restore
    await this.auth.initialize();

    // If already logged in → redirect to dashboard
    if (this.auth.isLoggedIn()) {
      await this.router.navigate([this.auth.homePath()]);
      return false;
    }

    // Not logged in → allow access
    return true;
  }
}
